import { render, staticRenderFns } from "./BackerCenterPledgesPreview.vue?vue&type=template&id=0f7829dc"
import script from "./BackerCenterPledgesPreview.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgesPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports